import FingerprintJS from '@fingerprintjs/fingerprintjs';

const TIMEOUT_MS = 2000;

export const getDeviceFingerprint = async (): Promise<string> => {
  const degraded = () => `degraded:${crypto.randomUUID()}`;

  const timeoutPromise = new Promise<string>((resolve) => {
    setTimeout(() => resolve(degraded()), TIMEOUT_MS);
  });

  const fingerprintPromise = (async () => {
    const fp = await FingerprintJS.load();
    const result = await fp.get();
    return result.visitorId;
  })().catch(() => degraded());

  return Promise.race([fingerprintPromise, timeoutPromise]);
};
